// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UAon","newExpiryDate":"styles_newExpiryDate__1iq5g","footer":"styles_footer__t84VE"};